// extracted by mini-css-extract-plugin
export default {"noApplication":"NothingSelectedView_noApplication","container":"NothingSelectedView_container"};